import { render } from "./SeatPlanCard.vue?vue&type=template&id=36b4365f&scoped=true"
import script from "./SeatPlanCard.vue?vue&type=script&lang=js"
export * from "./SeatPlanCard.vue?vue&type=script&lang=js"

import "./SeatPlanCard.vue?vue&type=style&index=0&id=36b4365f&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b4365f"]])

export default __exports__